module.exports = __webpack_public_path__ + "static/media/Vendor6.0725be7c.jpg";